import { render, staticRenderFns } from "./handover_list.vue?vue&type=template&id=6fcd1bb3&scoped=true"
import script from "./handover_list.vue?vue&type=script&lang=js"
export * from "./handover_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd1bb3",
  null
  
)

export default component.exports